import appEnv from 'app-env'
const config = Object.freeze({
  /** プロダクトのID（ユーザーの属性情報を取得する時に使用） */
  sysId: 'disaster-emergency',
  /** プロダクトのタイトル */
  sysName: '応急危険度判定アプリ',
  /** AWSのリージョン（'ap-northeast-1'） */
  region: 'ap-northeast-1',
  /**
   * ローディング中の画面に表示するデフォルトの画像
   * ('processing-[数字]', [数字]は1から14の範囲。
   * または他のファイルを指定する場合、gif形式なら省略し、その他の形式なら拡張子を付ける)
   */
  loadingImage: 'processing-08',
  /** 認証APIのエンドポイント（$config.authEndpointを指定） */
  authEndpoint: appEnv.PUB_AUTH_ENDPOINT,
  /** プロビジョニングした際に生成されたエンドポイント（$config.apiGwEndpointOperationを指定） */
  apiGwEndpointOperation: appEnv.PUB_API_GATEWAY_ENDPOINT_OPERATION,
  /** プロビジョニングした際に生成されたエンドポイント - 共通コンポーネント */
  apiGwEndpointCommon: appEnv.PUB_API_GATEWAY_ENDPOINT_COMMON,
  /** プロビジョニングした際に生成されたエンドポイント - 応急危険度判定アプリ */
  apiGwEndpointEmergency: appEnv.PUB_API_GATEWAY_ENDPOINT_EMERGENCY,
  /** 認証についての設定 */
  authorization: Object.freeze({
    /** 認証機能を使用するかどうか */
    mustAuth: true,
    /** 認証としてCognitoを使用するかどうか */
    cognitoEnable: true,
    /** サインアップを有効にするかどうか */
    userSignupEnable: true,
    /** API Gatewayの認可(IAMロール: iam、Custom Authorizer: custom_authorizer) */
    method: 'iam',
    /** 統合認証APIのサブディレクトリ */
    authSubDir: appEnv.PUB_MFA_ENABLE === true ? 'miiafw-auth-mfa' : 'miiafw-auth', // 標準認証用
    /** cognito アイデンティティプールID（$config.identityPoolIdを指定） */
    identityPoolId: appEnv.PUB_IDENTITY_POOL_ID,
    /** cognito ユーザープールID（$config.userPoolIdを指定） */
    userPoolId: appEnv.PUB_USER_POOL_ID,
    /** cognito クライアントID（$config.clientPoolIdを指定） */
    clientId: appEnv.PUB_CLIENT_ID,
    /** 認証APIのエンドポイント（$config.authorization.authEndpointを指定） */
    authEndpoint: appEnv.PUB_AUTHORIZATION_AUTH_ENDPOINT,
    /** Cognito Identity APIエンドポイント（閉域網利用で設定される） */
    cognitoIdentityEndpoint: null,
    /** パスワードの有効期限（日） */
    expirationTime: Number.MAX_VALUE,
    /** 認証の有効期限（msec） */
    ttl: 60 * 60 * 1000 // アクセストークンおよびIDトークンの有効期間(ミリ秒、1h以下の値の場合は1hとなる。)

    // 以下、必要であれば各PJでコメントアウト

    // accessibleDomain: 'xxxxx.xxx', // Cookieの有効範囲(ドメイン)、サーバサイドの設定に合わせる。サーバサイドでDomain属性を指定しない場合やCookieを使用しない場合は不要
    /** Cookieの有効範囲(パス)。サーバサイドの設定に合わせる。サーバサイドでDomain属性を指定しない場合やCookieを使用しない場合は不要 */
    // accessiblePath: '/' // Cookieの有効範囲(ドメイン)、サーバサイドの設定に合わせる。サーバサイドでDomain属性を指定しない場合やCookieを使用しない場合は不要
  }),
  /** コンテンツ格納用のS3バケットの設定 */
  s3Access: Object.freeze({
    /** S3バケットの名前（$config.contentsBucket を指定） */
    contentsBucket: appEnv.PUB_CONTENTS_BUCKET,
    /** アップロード可能な最大のサイズ（Byte） */
    maxUploadSize: 52428800, // S3へアップロードするファイルの最大サイズ
    /** 閉域網でS3へアクセス時に使用するVPCエンドポイント(Interface) */
    vpcEndpoint: null,
    // /** [Depricated] 閉域用を用いた場合のS3バケットへアクセスするAPIのエンドポイント */
    endpoint: appEnv.PUB_S3_BUCKET_ENDPOINT
  }),
  /** 応急危険度判定アプリ固有の設定 */
  disasterEmergency: Object.freeze({
    /** 利用者の共通属性のキー */
    commonAttr: 'disaster-commonattr',
    /** アプリ起動中の撮影可能枚数上限
     * HoldTemporaryStore photoShootsTotalと見比べる
     */
    maxPhotoShootsLimit: 25000,
    /** indexedDBのversion */
    indexedDBVersion: {
      deviceAuth: 1,
      photoDB: 1,
      apiDB: 3,
      LeafletOfflineDB: 1
    },
    /** 一度のダウンロードで推奨されている地図画像数 */
    recommendedOfflineMapDownloadCount: 5000
  })
})

export default Object.freeze({ config })
